import React from 'react'
import Create from '../crud/create'
import fields from './fields'
import menuItems from './menuItems'

const CreateProductDiscount = (props) => {
  return (
    <Create
// @ts-ignore
      title='Add Discount to Product'
      fields={fields}
      apiPath='admin/product_discounts'
      successRedirectPath={() => '/ecommerce/product-discounts'}
      buildMenuItems={menuItems}
    />
  )
}

export default CreateProductDiscount
